import React, {useState} from 'react';
import {Link, withRouter} from 'react-router';
import {Button, Icon, IconButton, MenuListItem, WindowSizeConsumer} from '@albert-io/atomic';
import {history} from 'client/history';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import NewFolderModal from 'components/PracticeView/FoldersModal/NewFolderModal/NewFolderModal.react';

import './assignments-folders-wrapper.scss';

type AssignmentsFoldersWrapperProps = {
  children: React.ReactNode;
  router: any;
};

const AssignmentsFoldersWrapper = ({children, router}: AssignmentsFoldersWrapperProps) => {
  const [isFoldersModalOpen, setIsFoldersModalOpen] = useState(false);
  const {isFeatureEnabled: isAdaptiveDiagnosticsEnabled} =
    useIsFeatureFlagEnabled('adaptive_diagnostics');

  return (
    <WindowSizeConsumer>
      {({breakpoints, viewportWidth}) => {
        const isMobile = viewportWidth <= breakpoints.m;
        // Legacy keeps its desktop-only sidebar; mobile renders the bare page.
        if (isMobile) {
          return <>{children}</>;
        }
        return (
          <div className='flex'>
            <div className='assignments-folders-sidebar flex flex-col pt-x4 pr-x3 pb-x4 pl-x3'>
              <div>
                <>
                  <IconButton
                    className='mr-x1'
                    roundness='square'
                    icon='folder-plus'
                    variant='outlined'
                    color='primary'
                    label='New Folder'
                    onClick={() => setIsFoldersModalOpen(true)}
                    data-testid='assignments_new-folder-btn'
                    tooltip='New folder'
                  />
                  <Button
                    onClick={() => history.pushState(null, '/assignment-builder/create-assignment')}
                    data-testid='assignments_new-assignment-btn'
                  >
                    <Icon icon='plus' className='mr-x1' />
                    New Assignment
                  </Button>
                </>
              </div>
              <MenuListItem
                as={Link}
                to='/assignments'
                className='assignments-folders-sidebar__item mt-x3 mb-x1'
                selected={router.location.pathname?.startsWith('/assignments')}
                disableWhenSelected={false}
              >
                <Icon icon={['fal', 'file-alt']} className='fa-fw nav-submenu_assignments-icon' />
                Assignments
              </MenuListItem>
              {isAdaptiveDiagnosticsEnabled && (
                <MenuListItem
                  as={Link}
                  to='/diagnostics'
                  className='assignments-folders-sidebar__item mb-x1'
                  selected={router.location.pathname === '/diagnostics'}
                  disableWhenSelected={false}
                >
                  <Icon
                    icon={['fal', 'file-contract']}
                    className='fa-fw nav-submenu_assignments-icon'
                  />
                  Diagnostics
                </MenuListItem>
              )}
              <MenuListItem
                as={Link}
                to='/saved'
                className='assignments-folders-sidebar__item'
                selected={router.location.pathname?.startsWith('/saved')}
                disableWhenSelected={false}
              >
                <Icon
                  icon={['fal', 'folder-open']}
                  className='fa-fw nav-submenu_assignments-icon'
                />
                Folders
              </MenuListItem>
            </div>
            <div style={{flex: 1}}>{children}</div>
            {isFoldersModalOpen && (
              <NewFolderModal handleClose={() => setIsFoldersModalOpen(false)} />
            )}
          </div>
        );
      }}
    </WindowSizeConsumer>
  );
};

export default withRouter(AssignmentsFoldersWrapper);
